<template>
  <div>
    <slot
        :item="item"
    ></slot>
  </div>
</template>

<script>
export default {
  name: "NewsItem",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>